import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Stack,
  Typography
} from '@mui/material';

import ModalForm from 'components/ui/Modal/UserModal';
import { BiLoader } from 'react-icons/bi';
import { backendURL } from 'redux/reducers/settings';
import {
  useCourseRosterQuery,
  useTrainingDetailQuery
} from 'redux/reducers/user/dashboard/tms-dashboardTrainee';
import PrintableSchedule from './RoutineSchedule';

const Module = ({
  activeModule,
  onSetActiveModule
}: {
  activeModule: string;
  onSetActiveModule: (moduleId: string) => void;
}) => {
  const { training_id: routineId } = useParams<{ training_id: string }>();
  const { data: traineeModuleList = [] } = useTrainingDetailQuery(routineId ?? '');

  const [selectedModule, setSelectedModule] = useState('');

  const { data: rosterDetail, isLoading: isLoadingRoster } = useCourseRosterQuery(
    routineId ?? '',
    selectedModule
  );

  useEffect(() => {
    if (traineeModuleList.length > 0) {
      onSetActiveModule(traineeModuleList?.[0]?.courses_list.id??'');
    }
  }, [traineeModuleList, onSetActiveModule]);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: '10px',
          justifyContent: 'space-between',
          flexWrap: 'wrap'
        }}>
        {traineeModuleList.map((module: any) => {
          const item = module.courses_list;
          return (
            <Card
              key={item.id}
              sx={{
                minWidth: '200px',
                border: 'none',
                borderRadius: '16px',
                boxShadow: '0px 4px 24px 0px rgba(24, 41, 47, 0.09)',
                width: { xs: '100%', md: 'calc(33% - 10px)' }, // optional responsive width
                height: { xs: 'auto', md: '390px' },
                mb: '20px'
              }}>
              <CardMedia
                component="img"
                height="250"
                image={backendURL + item.image}
                alt={item.title}
          sx={{ height: 100, objectFit: 'contain' }}

              />
              <CardContent>
                <Typography
                  gutterBottom
                  fontSize={14}
                  component="div"
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical'
                  }}>
                  {item.title}
                </Typography>
              </CardContent>

              <CardActions>
                <Stack direction="row" justifyContent="space-between" sx={{ width: '100%' }}>
                  <Button
                    size="small"
                    disabled={activeModule === item.id}
                    onClick={() => onSetActiveModule(item.id)}>
                    View Details
                  </Button>
                  <Button size="small" onClick={() => setSelectedModule(item.id)}>
                    View Schedule
                  </Button>
                </Stack>
              </CardActions>
            </Card>
          );
        })}
      </Box>

      <ModalForm
        title="Schedule Details"
        open={!!selectedModule}
        modalSize="xl"
        onClose={() => setSelectedModule('')}>
        {isLoadingRoster ? (
          <BiLoader />
        ) : rosterDetail?.data ? (
          <PrintableSchedule rosterInfo={rosterDetail?.data} />
        ) : (
          <Typography textAlign="center">Failed to load schedule details</Typography>
        )}

        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
          <Button title="close" variant="contained" onClick={() => setSelectedModule('')}>
            Close
          </Button>
        </Box>
      </ModalForm>
    </>
  );
};

export default Module;
